/*
 * Created on 13.12.2018
 *
 * Copyright(c) 1995 - 2018 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { Observable, OperatorFunction } from 'rxjs';

/**
 * Eine modifizierte Version von RxJS Buffer Operator, mit den Unterschied, dass das Ergebnis sofort,
 * ohne Verzögerung geliefert wird.
 * Es wird für Type-Ahead Suche in der Selectbox verwendet.
 * @param closingNotifier
 */
export function fastBuffer<T>(closingNotifier: Observable<any>): OperatorFunction<T, T[]> {
    // https://rxjs.dev/guide/operators#creating-new-operators-from-scratch
    return (source: Observable<T>) =>
        new Observable<T[]>((subscriber) => {
            // this function will be called each time this Observable is subscribed to.
            let buffer: T[] = [];

            // Subscribe to the closing notifier.
            closingNotifier.subscribe(() => {
                // clear buffer after the closing notifier has emitted an event
                buffer = [];
            });

            const subscription = source.subscribe({
                next(value) {
                    // add value to the buffer
                    buffer.push(value);
                    // and emit the entire buffer
                    subscriber.next(buffer);
                },
                error(err) {
                    buffer = [];
                    // We need to make sure we're propagating our errors through.
                    subscriber.error(err);
                },
                complete() {
                    buffer = [];
                    subscriber.complete();
                }
            });

            // Return the finalization logic. This will be invoked when the result errors, completes, or is unsubscribed.
            return () => {
                buffer = [];
                subscription.unsubscribe();
            };
        });
}
